/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Ledger_Col_ItemInputs */

const en_mk_sec_pg_ledger_col_item = /** @type {(inputs: Mk_Sec_Pg_Ledger_Col_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const id_mk_sec_pg_ledger_col_item = /** @type {(inputs: Mk_Sec_Pg_Ledger_Col_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hal`)
};

/**
* | output |
* | --- |
* | "Item" |
*
* @param {Mk_Sec_Pg_Ledger_Col_ItemInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_ledger_col_item = /** @type {((inputs?: Mk_Sec_Pg_Ledger_Col_ItemInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Ledger_Col_ItemInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_ledger_col_item(inputs)
	return en_mk_sec_pg_ledger_col_item(inputs)
});